<template>
  <div class="govuk-page-overlay" :id="identifier" v-show="!state.hidden">
    <div class="govuk-page-overlay-content">
      <div class="govuk-page-overlay-content-header" :id="titleId">
        <slot name="title">
          <span v-html="displayTitle"></span>
        </slot>
      </div>
      <div class="govuk-page-overlay-content-body" :id="contentId">
        <slot name="content" :descriptionId="descriptionId" :displayDescription="displayDescription"
          :descriptionHidden="descriptionHidden" :hiddenHint="state.hiddenHint" :displayHint="displayHint"
          :displayHintText="displayHintText" :displayHintClasses="displayHintClasses"
          :toggleHintSection="toggleHintSection">
          <slot name="description" :descriptionId="descriptionId" :displayDescription="displayDescription"
            :descriptionHidden="descriptionHidden">
            <div class="govuk-title" :id="descriptionId" v-show="!descriptionHidden" v-html="displayDescription"></div>
          </slot>
          <div :class="displayHintClasses" v-if="displayHint" v-on:click="toggleHintSection" v-html="displayHintText">
          </div>
          <div :id="hintId" class="govuk-hint" v-show="!state.hiddenHint" v-html="displayHint"></div>
          <template v-if="mtdt.Tree">
            <recursive-component :structure="mtdt.Tree" :identifier="identifier" :level="level"></recursive-component>
          </template>
        </slot>

      </div>
      <div class="govuk-page-overlay-content-buttons">
        <span class="govuk-button right" v-on:click="hide()">{{ t('Close',identifier) }}</span>
      </div>
    </div>
  </div>
</template>
<script lang="ts" src="@/library/templates/default/controls/Overlay.ts"></script>
